import { FormEvent, useEffect, useState } from "react";
import { useTextInput } from "../../hooks/useTextField";
import { useError } from "../../context/error";
import { StreamService } from "../../services/stream.service";
import { useSuccess } from "../../context/success";
import { Box, Paper, TextField, Typography } from "@mui/material";
import { StyleHelper } from "../style-helper";
import LoadingButton from "../controls/loading-btn";
import { SendOutlined } from "@mui/icons-material";
import { useGlobalState } from "../../context/global";
import { useStreamStatus } from "../../context/streamStatus.context";



export default function MessageSender() {
    const [message, setMessage] = useState('')
    const [isMessageSending, setIsMessageSending] = useState(false)
    const { setError } = useError()
    const { setSuccess } = useSuccess()
    const { streamStatus } = useStreamStatus()
    const streamService = new StreamService(setError)


    const [show, setShow] = useState(false)
    const _sendMessage = async (e: FormEvent) => {
        e.preventDefault()
        setIsMessageSending(true)
        const res = await streamService.postMessage(message, streamStatus?.streamId ?? "")
        if (res.success) {
            setMessage('')
            setSuccess(`Dutch received your message.`)
        }
        setIsMessageSending(false)

    }

    useEffect(() => {
        if(streamStatus.state === 'LIVE'){
            setTimeout(() => {
                setShow(true)
            }, 4000)
        }else{
            setShow(false)

        }
    }, [streamStatus])
    if (show)
        return <Paper elevation={3} sx={{ width: '100%', mt: 2 }}>
            <Box p={3} width="100%">
                <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                    Send Dutch a message
                </Typography>
                <Typography variant="body2">This is your direct line to Dutch! Only Dutch himself will see your message.</Typography>
                <StyleHelper.VerticalSpace />
                <form onSubmit={_sendMessage}>
                    <Box display="flex" width={"100%"} alignItems={'center'}>
                        <Box display="flex" flex={4}>
                            <TextField
                                label="Send a Message"
                                required
                                variant="outlined"
                                fullWidth
                                multiline={true}
                                rows={3}
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                                inputProps={{ maxLength: 500 }}
                                helperText={`${message.length}/500`}
                            />
                        </Box>
                        <StyleHelper.HorizontalSpace />
                        <Box display="flex" flex={1}>
                            <LoadingButton loading={isMessageSending} disabled={isMessageSending} type="submit" variant="outlined" color="secondary" endIcon={<SendOutlined />} >Send</LoadingButton>
                        </Box>
                    </Box>
                </form>
            </Box>
        </Paper>

        return <></>
}